import React from "react";
import { Modal, Box, Typography, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface ConfirmationModalProps {
    open: boolean;
    onConfirm: () => void;
    onCancel: () => void;
    title: string;
    message: any;
    confirmText: string;
    cancelText: string;
    showCloseIcon?: boolean;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
    open,
    onConfirm,
    onCancel,
    title,
    message,
    confirmText,
    cancelText,
    showCloseIcon = false,
}) => {
    return (
        <Modal
            open={open}
            onClose={onCancel}
            aria-labelledby="confirmation-modal-title"
            aria-describedby="confirmation-modal-description"
        >
            <Box className="center-model" sx={{ p: 4, position: "relative", width: "auto", minWidth: 300, maxWidth: 600, maxHeight: "80vh", boxSizing: "border-box", overflow: "auto" }}>
                {showCloseIcon && (
                    <IconButton
                        aria-label="close"
                        onClick={onCancel}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                        size="large"
                    >
                        <CloseIcon />
                    </IconButton>
                )}
                <Typography
                    id="confirmation-modal-title"
                    variant="h6"
                    component="h2"
                >
                    {title}
                </Typography>
                <Typography id="confirmation-modal-description" sx={{ m: 2 }}>
                    {message}
                </Typography>
                { confirmText &&
                   <Button
                       sx={{ m: 2, p: 1 }}
                       onClick={onConfirm}
                   >
                       {confirmText}
                   </Button>
                }
                {cancelText && 
                <Button sx={{ m: 2, p: 1 }} onClick={onCancel}>
                    {cancelText}
                </Button>
                }
            </Box>
        </Modal>
    );
};

export default ConfirmationModal;